import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { slugify } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { useProvinceName } from "../../../../components/AddressInput";

export function AustraliaLicenceSummaryField({
  field,
}: {
  field: components["schemas"]["AustraliaLicenceCheckField"];
}) {
  const { t } = useTranslation();
  const getProvinceName = useProvinceName("AU");

  if (!field.value) {
    return (
      <InnerContentItem label={field.label} provided={false}>
        Not provided
      </InnerContentItem>
    );
  }

  return (
    <>
      <InnerContentItem label={field.label.toUpperCase()} />
      <InnerContentItem
        label={t("Licence No.")}
        testID={`aus-licence-summary-${slugify(field.label)}-number`}
      >
        {field.value.number}
      </InnerContentItem>
      <InnerContentItem
        label={t("State / Territory issued")}
        testID={`aus-licence-summary-${slugify(field.label)}-state`}
      >
        {getProvinceName(field.value.issuing_state_province_or_territory)}
      </InnerContentItem>
    </>
  );
}
